module.exports = __webpack_public_path__ + "static/img/silder65.1dbe31b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/silder65.png
// module id = ludX
// module chunks = 37